import { lazy } from "react";

export const LessonsPage = lazy(() => import("./lessonsPage"));
